module.exports = __webpack_public_path__ + "img/noto-sans-jp-v25-latin-700.f4367e5.svg";